<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)" v-if="!screenIsWideEnough" />
    </v-app-bar>
    <v-content>
      <div :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }">
        <v-tabs class="grey lighten-2" background-color="grey lighten-3">
          <v-tabs-slider color="accent"></v-tabs-slider>
          <v-tab v-if="UserHasRole('Provider')">Enquiries</v-tab>
          <v-tab v-if="UserHasRole('Partner')">Referrals</v-tab>
          <v-tab-item v-if="UserHasRole('Provider')">
            <FunderStatsView />
          </v-tab-item>
          <v-tab-item v-if="UserHasRole('Partner')">
            <PartnerStatsView />
          </v-tab-item>
        </v-tabs>
      </div>
    </v-content>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PartnerStatsView from './Components/PartnerStatsView';
import FunderStatsView from '@/components/Platform/Dashboards/Components/FunderStatsView';

export default {
  name: 'TabbedDashboard',
  components: { FunderStatsView, PartnerStatsView },
  computed: {
    ...mapGetters(['UILeftDrawer', 'UserHasRole']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  methods: {
    ...mapActions(['updateUILeftDrawerState'])
  }
};
</script>
